import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "yesNo",
  standalone: true,
})
export class YesNoPipe implements PipeTransform {
  translate = inject(TranslateService);
  transform(value: unknown): unknown {
    if (typeof value === "boolean") {
      if (value) {
        return this.translate.instant("common.yes");
      } else {
        return this.translate.instant("common.no");
      }
    } else {
      return value;
    }
  }
}
